import React from "react";
import { Wrapper } from "./UserCardEntity.styled";
import avatar from "../../../../assets/svg/boy-avatar.svg";
import useredit from "../../../../assets/images/user-edit.png";
import { useHistory } from "react-router";
import { getUserPermissions } from "utils/text";
import { FaCreditCard, FaAmazonPay, FaHome } from 'react-icons/fa';
import { MdEmail } from 'react-icons/md';

const UserCardEntity = ({ data, handleLoginAsUser }) => {
  const history = useHistory();
  return (
    <Wrapper>
      <div className="header">
        <div className="info">
          <div className="image-container">
            {data.profilePicture ? (
              <img src={data.profilePicture} alt="User Profile" className="image" />
            ) : (
              <img src={avatar} alt="User Profile" className="image" />
            )}
          </div>
          <div className="name">{data?.username}</div>
        </div>
        {getUserPermissions("edit-user-action") && (
          <img src={useredit} alt="User Edit" onClick={() => history.push(`/user/${data?._id}`)} />
        )}
      </div>

      <div className="body">
        <div className="content">
          <MdEmail size={20} />
          <div className="text">{data?.email}</div>
        </div>
        <div className="content">
          <FaCreditCard size={20} />
          <div className="text">{data?.sitPayAmount}</div>
        </div>
        <div className="content">
          <FaAmazonPay size={20} />
          <div className="text">{data?.kwPay}</div>
        </div>
        <div className="content">
          <FaHome size={20} />
          <div className="text">{data?.locationName?.name}, {data?.locationName?.state}</div>
        </div>
      </div>

      <div className="footer">
        {getUserPermissions("delete-user-action") && (
          <button className="login-button" onClick={() => handleLoginAsUser(data?.email, data?.password)}>Login</button>
        )}
      </div>
    </Wrapper>
  );
};

export default UserCardEntity;
